import { Button } from '@mui/material';
import { Datagrid, FunctionField, List, TextInput, TopToolbar, useListContext } from 'react-admin';
import MyPagination from '../MyPagination';

const SortActions = () => {
	const { sort, setSort } = useListContext();
	return (
		<TopToolbar>
			<Button
				size="small"
				variant={sort.order === 'DESC' ? 'contained' : 'outlined'}
				onClick={() => setSort({ field: 'createdAt', order: 'DESC' })}
			>
				הכי חדשות
			</Button>
			<Button
				size="small"
				variant={sort.order === 'ASC' ? 'contained' : 'outlined'}
				onClick={() => setSort({ field: 'createdAt', order: 'ASC' })}
			>
				הכי ישנות
			</Button>
		</TopToolbar>
	);
};

const OnboardingNotesList = () => {
	return (
		<List
			resource="member-notes"
			perPage={20}
			pagination={<MyPagination />}
			sort={{ field: 'createdAt', order: 'DESC' }}
			title="שיתופים מהאונבורדינג"
			actions={<SortActions />}
			filters={[<TextInput source="company" label="חברה" alwaysOn />]}
		>
			<Datagrid bulkActionButtons={false} rowClick={false}>
				<FunctionField label="חברה" render={(record: any) => record?.company ?? '-'} />
				<FunctionField
					label="שיתוף"
					render={(record: any) => (
						<span style={{ whiteSpace: 'pre-wrap', display: 'block', maxWidth: 700 }}>
							{record?.text ?? ''}
						</span>
					)}
				/>
			</Datagrid>
		</List>
	);
};

export default OnboardingNotesList;
